class ProductGroup extends HTMLElement {
    connectedCallback() {
        const loadProductGroup = async (groupId) => {
            try {
                const res = await fetch(`/pages/product-group?group=${groupId}`);
                const text = await res.text();
                const doc = new DOMParser().parseFromString(text, 'text/html');

                doc.querySelectorAll('[data-group-id]').forEach(el => {
                    if (el.dataset.groupId != this.dataset.groupId) el.remove();
                });

                const limitToHide = Number(this.dataset.limitHide || 0);

                if (limitToHide > 0) {
                    const cards = Array.from(doc.querySelectorAll('.product-group-card'));

                    if (cards.length > limitToHide) {
                        const visibleCards = cards.slice(0, limitToHide);
                        const hiddenCards = cards.slice(limitToHide);

                        const hiddenWrapper = document.createElement('div');
                        hiddenWrapper.classList.add('product-group-hidden');

                        hiddenCards.forEach(card => hiddenWrapper.appendChild(card));

                        visibleCards.forEach(card => doc.body.querySelector('.product-group').appendChild(card));

                        const counter = document.createElement('span');
                        doc.body.querySelector('.product-group').appendChild(counter);
                        counter.textContent = `+${hiddenCards.length}`;

                        doc.body.appendChild(hiddenWrapper);
                    }
                }

                this.innerHTML = doc.body.innerHTML;
            } catch (error) {
                console.log('ProductGroup Error: ', error);
                this.remove();
            }
        };

        loadProductGroup(this.dataset.groupId).then(() => {
            if (!this.querySelectorAll('.product-group-card').length) this.remove();
        });
    }
}

if (!customElements.get('product-group')) {
    customElements.define('product-group', ProductGroup);
}
